import { Button } from '../../ui/Button/Button';

const PROGRESS_NODES: Record<number, string> = {
  1: '124:32997',
  2: '176:46602',
  3: '124:33679',
  4: '2721:50923',
  5: '2723:52554',
  6: '2723:51755',
  7: '2736:36375',
  8: '2736:37047',
  9: '2736:37781',
};

export interface RequestProgressProps {
  current: number;
  label: string;
  onBack?: () => void;
}

export function RequestProgress({ current, label, onBack }: RequestProgressProps) {
  return (
    <div className="request-wizard__progress" data-figma-node="124:31956">
      <div
        className="request-wizard__progress-bars"
        data-figma-node={PROGRESS_NODES[current] ?? PROGRESS_NODES[9]}
        data-figma-variant={`Step=${current}`}
      >
        {Array.from({ length: 9 }, (_, index) => (
          <i className={index < current ? 'is-active' : ''} key={index} />
        ))}
      </div>
      <div className="request-wizard__progress-meta">
        {onBack ? (
          <Button kind="tertiary" size="medium" icon="left" onClick={onBack}>
            Назад
          </Button>
        ) : (
          <span aria-hidden="true" />
        )}
        <span className="request-wizard__progress-label">
          <b>Шаг {current}</b>
          <i aria-hidden="true" />
          <span>{label}</span>
        </span>
      </div>
    </div>
  );
}
